import React from 'react';
import './Tabs.css';
import { useRestaurantSections } from '../../data/RestaurantSections';
const Tabs = ({ activeSection, setActiveSection }) => {
  const { sections = [], isLoading, error } = useRestaurantSections();

  return (
    <div className="tabs">
      {isLoading ? (
        <div>Loading sections...</div>
      ) : error ? (
        <div>Error loading sections: {error.message || 'Unknown error'}</div>
      ) : !sections?.length ? (
        <div>No sections available</div>
      ) : (
        sections.map(section => (
          <div
            key={section.id}
            className={`tab ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => setActiveSection(section.id)}
          >
            {section.name}
          </div>
        ))
      )}
    </div>
  );
};

export default Tabs;